<template>
  <div class="errPage-container">  
    <div class="row">
         <div class="col-md-6">
        <img :src="errGif" width="313" height="428" alt="Girl has dropped her ice cream.">
      </div>
      <div class="col-md-6">
        <h1 class="text-jumbo text-ginormous">Oops! 403</h1>
        <h2>Você não tem permissão para ir a esta página</h2>
        
        <b>{{message}}</b>
        <h5>Se você estiver insatisfeito, entre em contato com seu <b>líder</b>.</h5>
        <br>
        <ul class="list-unstyled">
            <router-link class="btn btn-default" to="/"><i class="fa fa-arrow-left"></i> {{$t('words.back')}}</router-link>
        </ul>
      </div>     
    </div>
  </div>
</template>

<script>
import errGif from '../../assets/401_images/401.gif';
export default {
  name: 'page401',
  data() {
    return {
      errGif: errGif + '?' + new Date(),
      ewizardClap:
        'https://wpimg.wallstcn.com/007ef517-bafd-4066-aae4-6883632d9646',
      dialogVisible: false,
      message: null
    };
  },
  mounted() {
    this.message = this.$route.params.message;
  },
  methods: {
    back() {
      if (this.$route.query.noGoBack) {
        this.$router.push({ path: '/home' });
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.errPage-container {
  width: 800px;
  margin: 50px auto;
  .pan-back-btn {
    background: #008489;
    color: #fff;
    border: none !important;
  }
  .pan-gif {
    margin: 0 auto;
    display: block;
  }
  .pan-img {
    display: block;
    margin: 0 auto;
    width: 100%;
  }
  .text-jumbo {
    font-size: 60px;
    font-weight: 700;
    color: #484848;
  }
  .list-unstyled {
    font-size: 14px;
    li {
      padding-bottom: 5px;
    }
  }
}
</style>
